import { Skeleton, TableRow } from '@mui/material'
import React from 'react'
import CustomTableCell from '../common/CustomTableCell'

interface LoadingTableRowProps {
    numberOfRows: number
}

const LoadingTableRow: React.FC<LoadingTableRowProps> = ({ numberOfRows }: LoadingTableRowProps) => {
    return (
        <TableRow
            tabIndex={-1}
            style={{
                height: '42px',
            }}
        >
            {
                Array.from(Array(numberOfRows).keys()).map((_, index) => (
                    <CustomTableCell key={index} disablePadding>
                        <Skeleton variant="rectangular" width='100%' height='42px' />
                    </CustomTableCell>
                ))
            }
        </TableRow>
    )
}

export default LoadingTableRow